import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class ServiceService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async GetService() {
        var url = this.endpoint + `/Service`;
        return this.api({
            method: 'get',
            url
        });
    }

    async GetServiceById(serviceId: number) {
        var url = this.endpoint + `/Service?$filter=id eq ${serviceId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getByUserId(userId: number, areaId: number, customerId: number, serviceGroupId: number) {
        const url = this.endpoint + `/Service/User/${userId}/${areaId}/${customerId}/${serviceGroupId}`;

        return this.api({
            method: 'get',
            url
        })
    }

    async getForm(IdProcess: number, IsAttendant: boolean, isReadOnly: boolean, IdService: number, IdSolicitation: number) {
        var url = this.endpoint + `/Process/GetMultiFormV4/${IdProcess}/${IsAttendant}/${isReadOnly}/${IdService}/${IdSolicitation}`;
        return this.api({
            method: 'get',
            url
        });
    }

    async GetByServiceGroupFilter(ServiceGroupId: string, CustomerIds?: string) {
        var url = this.endpoint + `/Service/GetByServiceGroupFilter/${ServiceGroupId}`;

        if (CustomerIds) {
            url += `/?CustomerIds=${CustomerIds}`;
        }
        
        return this.api({
            method: 'get',
            url
        });
    }

    async GetServiceManager(userId: number, serviceGroupId: number) {
        var url = this.endpoint + `/Service/Manager/${userId}/${serviceGroupId}`;
        return this.api({
            method: 'get',
            url
        });
    }

    async getServiceGroups(serviceGroupId: number) {
        var url = `${this.endpoint}/Service?$filter=IdServiceGroup eq ${serviceGroupId}&$top=3000`;

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }

    async GetServiceByRequesterIdAndSolicitationGroupId(requesterId: number, solicitationGroupId: number) {
        var url = `${this.endpoint}/Service/GetServiceByRequesterIdAndSolicitationGroupId/${requesterId}/${solicitationGroupId}`;

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }
}